import USBBPAvatarComponent from './components/AvatarComponent';
import USBBPAvatarFigureComponent from './components/AvatarFigureComponent';
import USBBPAvatarIconComponent from './components/AvatarIconComponent';

export { USBBPAvatarFigureComponent, USBBPAvatarIconComponent };
export default USBBPAvatarComponent;
